<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15jrE4j/tc-custom/9781426821769.jpg?1726617359223" alt="This image is the cover for the book Hitched to the Horseman, Men of the West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hitched to the Horseman, Men of the West
      </h1>
      <p class="bookDescription body article font2">
        <p>Gabe Trevino came to the family-owned Sandbur Ranch to train horses, not fall for the boss's daughter. The sultry ranching heiress could ride and rope as well as any man. She was also hiding something, tempting Gabe to solve the enigma that was beautiful, vulnerable Mercedes Saddler.<br/><br/>Mercedes knew better than to trust the handsome cowboy. She'd come home to Texas to start over on the ranch she loved. And Sandbur's new head horse trainer was a man who could break her heart as easily as he could break a foal. But Gabe called to something deep within her, making her yearn to heal the past and build a future with this lonesome, wary-of-love loner.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stella Bagwell
      </h2>
      
      <p class="authorDescription body article">The author of over seventy-five titles for Harlequin, Stella Bagwell writes about familes, the West, strong, silent men of honor and the women who love them. She credits her loyal readers and hopes her stories have brightened their lives in some small way. A cowgirl through and through, she recently learned how to rope a steer. Her days begin and end helping her husband on their south Texas ranch. In between she works on her next tale of love. Contact her at stellabagwell@gmail.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8f305a18